import React from 'react';
import './MenuDropdown.css';

export interface MenuItem {
  label?: string | React.ReactNode;
  shortcut?: string;
  action?: () => void;
  disabled?: boolean;
  divider?: boolean;
  noHover?: boolean; // Don't apply hover styles
  className?: string; // Additional CSS class
}

interface MenuDropdownProps {
  items: MenuItem[];
  onClose: () => void;
  position: { x: number; y: number };
  className?: string;
}

const MenuDropdown: React.FC<MenuDropdownProps> = ({ items, onClose, position, className }) => {
  const handleItemClick = (item: MenuItem) => {
    if (!item.disabled && item.action) {
      item.action();
    }
    onClose();
  };

  return (
    <>
      <div className="menu-dropdown-overlay" onClick={onClose} style={{ top: '37px', height: 'calc(100vh - 37px)' }} />
      <div
        className={`menu-dropdown ${className || ''}`}
        style={{ left: position.x, top: position.y }}
      >
        <div className="menu-dropdown-shadow" />
        <div className="menu-dropdown-content">
          {items.map((item, index) => (
            <React.Fragment key={index}>
              {item.divider ? (
                <div className="menu-divider" />
              ) : (
                <div
                  className={`menu-dropdown-item ${item.disabled ? 'disabled' : ''} ${item.noHover ? 'no-hover' : ''} ${item.className || ''}`}
                  onClick={() => handleItemClick(item)}
                >
                  <span className="menu-item-label">{item.label}</span>
                  {item.shortcut && (
                    <span className="menu-item-shortcut">{item.shortcut}</span>
                  )}
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </>
  );
};

export default MenuDropdown;
